import { styled } from '@mui/system';
import { FormControl, MenuItem } from '@mui/material';

export const FormControlStyled = styled(FormControl)(({ theme }) => ({
  borderRadius: '0.3125rem',
  maxHeight: '44px',
  border: `0.0625rem solid ${theme?.palette?.dividerBorder}`,
  '& label, & .MuiInputBase-formControl': {
    '& .MuiSelect-icon': {
      right: '0.625rem',
      top: '1.125rem'
    },
    maxHeight: '44px',
    fontSize: '0.875rem',
    fontWeight: 400,
    fontFamily: 'Calibri',
    color: theme?.palette?.primaryDark
  }
}));

export const MenuItemStyled = styled(MenuItem)(({ theme }) => ({
  fontSize: '0.875rem',
  fontWeight: 400,
  fontFamily: 'Calibri',
  color: theme?.palette?.primaryDark
}));
